import { LANGUAGE_MAP, type LANGUAGE_TYPE, LANGUAGES } from "@web3auth/auth";

export function getUserLanguage(): LANGUAGE_TYPE {
  const { navigator } = window;
  let userLanguage = (navigator as unknown as { userLanguage: string }).userLanguage || navigator.language || "en-US";
  const userLanguageArr = userLanguage.split("-");
  userLanguage = Object.prototype.hasOwnProperty.call(LANGUAGE_MAP, userLanguageArr[0]) ? userLanguageArr[0] : LANGUAGES.en;
  return userLanguage as LANGUAGE_TYPE;
}
